import { defineMessages } from 'react-intl-next';

export default defineMessages({
	beta: {
		id: 'dev-agents.home.main-page.beta',
		defaultMessage: 'Beta',
		description: 'Beta lozenge label indicating the feature is in beta',
	},
	homeDescription: {
		id: 'dev-agents.home.main-page.home-description',
		defaultMessage:
			"By tapping into your team's knowledge in Jira, Confluence, and your codebase, Rovo Dev Agents can speed up delivery of high-quality code and let developers focus on more meaningful work.",
		description: 'Home page description for Rovo Dev Agents',
	},
	discoverMoreLinkLabel: {
		id: 'dev-agents.home.main-page.discover-more-link-label',
		defaultMessage: 'Discover more about Rovo Dev Agents',
		description: 'Documentation link label for Rovo Dev Agents',
	},
	connectSCMToolsHeading: {
		id: 'dev-agents.home.main-page.connect-scm-tools-heading',
		defaultMessage: 'Connect a source code management tool',
		description:
			'The heading for the section that allows users to connect a source code management tool',
	},
	connectSCMToolsDescription: {
		id: 'dev-agents.home.main-page.connect-scm-tools-description',
		defaultMessage:
			'To use Code Reviewer, Code Planner, or a coding agent, you need to connect Bitbucket or GitHub to Jira.',
		description:
			'The description for the section that allows users to connect a source code management tool',
	},
	setUpRovoDevAgentsHeading: {
		id: 'dev-agents.home.main-page.set-up-rovo-dev-agents-heading',
		defaultMessage: 'Setup Rovo Dev Agents',
		description:
			'The title of the block that asks user to setup Rovo Dev Agents before they can continue to use them.',
	},
	rovoDevAgentsHeading: {
		id: 'dev-agents.home.main-page.rovo-dev-agents-heading',
		defaultMessage: 'Rovo Dev Agents',
		description: 'The title of page for Rovo Dev Agents.',
	},
	skipConnectingForNow: {
		id: 'dev-agents.home.main-page.skip-connecting-for-now',
		defaultMessage: 'Skip connecting for now',
		description: 'The label for the button that skips connecting for now.',
	},
	show: {
		id: 'dev-agents.home.main-page.show',
		defaultMessage: 'Show',
		description: 'The label for the button that shows the setup section.',
	},
	hide: {
		id: 'dev-agents.home.main-page.hide',
		defaultMessage: 'Hide',
		description: 'The label for the button that hides the setup section.',
	},
});
